/** The one synthetic hour basis shared by BM01's planned and avoided stops. */
export const BM01_BEARING_STOP_HOURS = {
  plannedInspection: 4, // [syn] controlled inspection duration from the seeded maintenance action
  avoidedFailure: 57.6, // [syn] 2.4-day bearing MTTR from the seeded repair estimate, expressed in hours
} as const;

/** [syn] W3c proposed controlled stop, held once so the case and tree share its window. */
export const BM01_BEARING_PROPOSED_STOP = {
  at: '2026-06-13T06:00',
  label: 'Sat 13 Jun',
  shift: 'day',
  provenance: '[syn] proposed BM01 stop before the projected 85 °C limit; W3c reads this seed',
} as const;
